export const getGridFromNumber = (value: number) => {
    let x1 = '';
    if (value >= 26) {
        x1 = String.fromCharCode('A'.charCodeAt(0) + (value / 26 - 1));
    }
    const x2 = String.fromCharCode('A'.charCodeAt(0) + (value % 26));
    return x1 + x2;
};
